// planSurfaceEntitlements.js — Knowledge / Collections surface gates

/**
 * Whether the plan may show Collections (private module).
 * Always enabled — `collectionsEnabled` is no longer a plan setting.
 *
 * @param {object|null|undefined} [_features] - Unused; kept for call-site compatibility.
 * @returns {boolean}
 */
export function canUseCollections(_features) {
  return true;
}

/**
 * Whether Knowledge module UI is available.
 *
 * @param {object|null|undefined} features
 * @returns {boolean}
 */
export function canUseKnowledge(features) {
  return features?.knowledgeEnabled !== false;
}

/**
 * Whether Channels are available.
 *
 * @param {object|null|undefined} features
 * @returns {boolean}
 */
export function canUseChannels(features) {
  return features?.channelsEnabled !== false;
}

/**
 * @param {object|null|undefined} features
 * @returns {boolean}
 */
export function canUseDms(features) {
  return features?.dmsEnabled !== false;
}

/**
 * @param {object|null|undefined} features
 * @returns {boolean}
 */
export function canUseDashboards(features) {
  return features?.dashboardsEnabled !== false;
}

/**
 * @param {object|null|undefined} features
 * @returns {boolean}
 */
export function canUseApps(features) {
  return features?.appsEnabled !== false;
}

/**
 * Modules a member may search / Ask against.
 * Collections are always enabled → both modules (null = no filter).
 *
 * @param {object|null|undefined} [_features] - Unused; kept for call-site compatibility.
 * @returns {null|Array<'public'|'private'>}
 */
export function resolveMemberAskModules(_features) {
  return null;
}
